import React from 'react'
import { Mutation } from 'react-apollo'
import Datetime from 'react-datetime'
import moment from 'moment'
import { Form, Field } from 'react-final-form'

// graphql mutations
import createCoupon from '../../graphql/mutations/createCoupon'
import updateCoupon from '../../graphql/mutations/updateCoupon'

// material-ui components
import withStyles from 'material-ui/styles/withStyles'

// core components
import TextField from 'components/TextField/TextField'

// material-ui
import Modal from 'material-ui/Modal'
import FormControl from 'material-ui/Form/FormControl'
import InputLabel from 'material-ui/Input/InputLabel'
import Button from 'material-ui/Button'

// style
import modalStyle from 'assets/jss/material-dashboard-pro-react/modalStyle.jsx'

class CouponModalForm extends React.Component {
  onSubmit = (createCoupon, updateCoupon) => (values) => {
    const { isNewCoupon, onCloseModal } = this.props

    if (isNewCoupon) {
      createCoupon({
        variables: {
          coupon: {
            ...values,
            importo: parseInt(values.importo),
            dataLimiteAssegnazione: moment(
              values.dataLimiteAssegnazione,
              'DD/MM/YYYY',
              true
            ).format('YYYY-MM-DD HH:mm'),
            dataLimiteAttivazione: moment(values.dataLimiteAttivazione, 'DD/MM/YYYY', true).format(
              'YYYY-MM-DD HH:mm'
            ),
            dataLimiteUtilizzo: moment(values.dataLimiteUtilizzo, 'DD/MM/YYYY', true).format(
              'YYYY-MM-DD HH:mm'
            ),
          },
        },
        refetchQueries: ['coupons'],
      })
    } else {
      updateCoupon({
        variables: {
          coupon: {
            clienteId: values.clienteId,
            codice: values.codice,
            stato: values.stato,
            importo: parseInt(values.importo),
            dataLimiteAssegnazione: moment(
              values.dataLimiteAssegnazione,
              'DD/MM/YYYY',
              true
            ).format('YYYY-MM-DD HH:mm'),
            dataLimiteAttivazione: moment(values.dataLimiteAttivazione, 'DD/MM/YYYY', true).format(
              'YYYY-MM-DD HH:mm'
            ),
            dataLimiteUtilizzo: moment(values.dataLimiteUtilizzo, 'DD/MM/YYYY', true).format(
              'YYYY-MM-DD HH:mm'
            ),
          },
          id: values.id,
        },
      })
    }

    onCloseModal()
  }

  isValidDate = (date) => {
    const momentDate = moment(date, 'DD/MM/YYYY', true)
    return momentDate.isValid()
  }

  validate = (values) => {
    const errors = {}

    if (!values.codice) {
      errors.codice = 'Richiesto'
    }
    if (!values.importo) {
      errors.importo = 'Richiesto'
    }
    if (!values.dataLimiteAssegnazione || !this.isValidDate(values.dataLimiteAssegnazione)) {
      errors.dataLimiteAssegnazione = 'Richiesto'
    }
    if (!values.dataLimiteAttivazione || !this.isValidDate(values.dataLimiteAttivazione)) {
      errors.dataLimiteAttivazione = 'Richiesto'
    }
    if (!values.dataLimiteUtilizzo || !this.isValidDate(values.dataLimiteUtilizzo)) {
      errors.dataLimiteUtilizzo = 'Richiesto'
    }

    return errors
  }

  render() {
    const { classes, initialValues, isNewCoupon, open, onCloseModal, tipologie } = this.props

    return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={onCloseModal}
        disableBackdropClick={true}
      >
        <div className={classes.modal}>
          <div className={classes.modalHeader}>
            <h3 className={classes.modalTitle}>
              {initialValues.codice ? 'Modifica coupon' : 'Aggiungi coupon'}
            </h3>
            <span className={classes.modalCloseButton} onClick={onCloseModal}>
              <span className={classes.modalClose}>&times;</span>
            </span>
          </div>
          <Mutation mutation={createCoupon}>
            {(createCoupon) => (
              <Mutation mutation={updateCoupon}>
                {(updateCoupon) => (
                  <Form
                    onSubmit={this.onSubmit(createCoupon, updateCoupon)}
                    initialValues={initialValues}
                    validate={this.validate}
                    render={({ handleSubmit, reset, submitting, pristine, values, form }) => (
                      <form onSubmit={handleSubmit}>
                        <div className={classes.modalBody}>
                          {/* CODICE */}
                          <Field
                            name="codice"
                            label="Codice"
                            type="text"
                            margin="normal"
                            fullWidth
                            component={TextField}
                          />

                          {/* STATO */}
                          <Field
                            name="stato"
                            label="Stato"
                            margin="normal"
                            select
                            fullWidth
                            component={TextField}
                            className={classes.modalSelect}
                            disabled={isNewCoupon}
                            options={[
                              { value: '', label: '-- Seleziona --' },
                              { value: 'DA_ASSEGNARE', label: 'Da assegnare' },
                              {
                                value: 'DA_ATTIVARE',
                                label: 'Da attivare',
                              },
                              {
                                value: 'ATTIVATO',
                                label: 'Attivato',
                              },
                              {
                                value: 'PROPOSTA',
                                label: 'Proposta',
                              },
                              {
                                value: 'UTILIZZATO',
                                label: 'Utilizzato',
                              },
                              {
                                value: 'DISATTIVATO',
                                label: 'Disattivato',
                              },
                            ]}
                          />

                          {/* TIPOLOGIA */}
                          <Field
                            name="tipologia"
                            label="Tipologia"
                            margin="normal"
                            select
                            fullWidth
                            component={TextField}
                            className={classes.modalSelect}
                            options={tipologie.map((tipologia) => ({
                              value: tipologia,
                              label: tipologia,
                            }))}
                          />

                          {/* IMPORTO */}
                          <Field
                            name="importo"
                            label="Importo"
                            type="number"
                            margin="normal"
                            fullWidth
                            component={TextField}
                          />

                          {/* ASSEGNARE ENTRO, ATTIVARE ENTRO E UTILIZZARE ENTRO*/}
                          <div>
                            <div style={{ marginTop: 30 }}>
                              <InputLabel className={classes.label}>Assegnare entro il</InputLabel>
                              <br />
                              <FormControl fullWidth>
                                <Field
                                  name="dataLimiteAssegnazione"
                                  type="text"
                                  margin="normal"
                                  fullWidth
                                  render={({ input, meta }) => (
                                    <div>
                                      <Datetime
                                        {...input}
                                        onChange={(v) => {
                                          input.onChange(v)
                                          // form.change(
                                          //   'dataLimiteAttivazione',
                                          //   moment(v, 'YYYY-MM-DD', true).add(1, 'month')
                                          // )
                                          // form.change(
                                          //   'dataLimiteUtilizzo',
                                          //   moment(v, 'YYYY-MM-DD', true).add(2, 'month')
                                          // )
                                        }}
                                        dateFormat="DD/MM/YYYY"
                                        timeFormat={false}
                                      />
                                      {meta.touched && meta.error && (
                                        <span className={classes.metaError}>{meta.error}</span>
                                      )}
                                    </div>
                                  )}
                                />
                              </FormControl>
                            </div>
                            <div style={{ marginTop: 30 }}>
                              <InputLabel className={classes.label}>Attivare entro il</InputLabel>
                              <br />
                              <FormControl fullWidth>
                                <Field
                                  name="dataLimiteAttivazione"
                                  type="text"
                                  margin="normal"
                                  fullWidth
                                  render={({ input, meta }) => (
                                    <div>
                                      <Datetime
                                        {...input}
                                        onChange={(v) => {
                                          input.onChange(v)
                                        }}
                                        dateFormat="DD/MM/YYYY"
                                        timeFormat={false}
                                      />
                                      {meta.touched && meta.error && (
                                        <span className={classes.metaError}>{meta.error}</span>
                                      )}
                                    </div>
                                  )}
                                />
                              </FormControl>
                            </div>
                            <div style={{ marginTop: 30 }}>
                              <InputLabel className={classes.label}>Utilizzare entro il</InputLabel>
                              <br />
                              <FormControl fullWidth>
                                <Field
                                  name="dataLimiteUtilizzo"
                                  type="text"
                                  margin="normal"
                                  fullWidth
                                  render={({ input, meta }) => (
                                    <div>
                                      <Datetime
                                        {...input}
                                        onChange={(v) => {
                                          input.onChange(v)
                                        }}
                                        dateFormat="DD/MM/YYYY"
                                        timeFormat={false}
                                      />
                                      {meta.touched && meta.error && (
                                        <span className={classes.metaError}>{meta.error}</span>
                                      )}
                                    </div>
                                  )}
                                />
                              </FormControl>
                            </div>
                          </div>
                        </div>

                        <div className={classes.modalFooter}>
                          <div className="buttons">
                            <Button
                              className={classes.modalSmallFooterFirstButton}
                              type="submit"
                              disabled={submitting}
                              variant="raised"
                              color="primary"
                            >
                              {!!isNewCoupon ? 'Crea' : 'Salva modifiche'}
                            </Button>
                            <Button
                              className={classes.modalSmallFooterSecondButton}
                              onClick={onCloseModal}
                            >
                              Chiudi
                            </Button>
                          </div>
                        </div>
                      </form>
                    )}
                  />
                )}
              </Mutation>
            )}
          </Mutation>
        </div>
      </Modal>
    )
  }
}

export default withStyles(modalStyle)(CouponModalForm)



// WEBPACK FOOTER //
// ./src/components/CouponModalForm/CouponModalForm.jsx